import apiFetch from '../apiFetch'

export default function (serviceId, approvalRoleCode, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Service/${serviceId}/ApproveByRole?approvalRoleCode=${approvalRoleCode}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
